import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { useCallback } from 'react';
import { MessageBoxFunctionalLayout } from 'wix-style-react';

interface IDiscardChangesModal extends InjectedTranslateProps {
    onOk: Function;
    closeModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const DiscardChangesModal: React.FC<IDiscardChangesModal> = ({ t, onOk, closeModal }) => {

    const onStayOnPageClick = useCallback(async () => {
        await onOk();
        closeModal(undefined);
    }, [onOk, closeModal]);

    return (
        <MessageBoxFunctionalLayout
            title={t('modal.discardChanges.title')}
            confirmText={t('modal.discardChanges.cancel')}
            cancelText={t('modal.discardChanges.confirm')}
            onOk={onStayOnPageClick}
            onCancel={closeModal}
            onClose={closeModal}
            theme="red"
            dataHook="discardChangesModal"
        >
            {t('modal.discardChanges.innerText')}
        </MessageBoxFunctionalLayout>);
};

export default translate()(DiscardChangesModal);
